import axios from "axios";
import { useQuery, queryCache } from "react-query";

export function useGroupedTimerDataImportData(token) {
    return useQuery(
        "groupTimerDataImportData",
        async () => {
            const response = await axios.get("/api/time-track/importdata/grouped/get-timer", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    tz: global.config.getTimeZone(),
                },
            });

            return response.data || [];
        },
        {
            // Only enable query when token is available
            enabled: !!token,
            // Always fetch fresh data from database on mount
            // Cache is invalidated/removed in Calendar before navigation, so this ensures fresh fetch
            refetchOnMount: 'always', // Always refetch on mount to get fresh data from DB
            staleTime: 0, // Data is immediately stale, always fetch fresh
            cacheTime: 0, // Don't cache data, always fetch from DB
            onError: (error) => {
                console.error("useGroupedTimerDataImportData error:", error);
                global.config.slackMessage?.(error.toString());
            },
        }
    );
}

export function useTimerDataImportData(token) {
    return useQuery(
        "timerDataImportData",
        async () => {
            const response = await axios.get("/api/time-track/importdata/get-timer", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    tz: global.config.getTimeZone(),
                },
            });
            // Handle empty or invalid response
            if (!response.data || typeof response.data !== 'object') {
                console.warn("useTimerDataImportData: Invalid response data", response.data);
                return [];
            }
            
            // Transform object to array of [key, value] pairs
            const result = Object.keys(response.data).map((key) => [
                key,
                response.data[key],
            ]);
            return result;
        },
        {
            // Only enable query when token is available
            enabled: !!token,
            // Always fetch fresh data from database on mount
            // Cache is invalidated/removed in Calendar before navigation, so this ensures fresh fetch
            refetchOnMount: 'always', // Always refetch on mount to get fresh data from DB
            staleTime: 0, // Data is immediately stale, always fetch fresh
            cacheTime: 0, // Don't cache data, always fetch from DB
            onError: (error) => {
                console.error("useTimerDataImportData error:", error);
                global.config.slackMessage?.(error.toString());
            },
        }
    );
}

export function useTimerDataImportDataCalendar(token) {
    return useQuery(
        "timerDataImportDataCalendar",
        async () => {
            const response = await axios.get("/api/time-track/importdata/get-timer-calendar", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    tz: global.config.getTimeZone(),
                },
            });
            // Handle empty or invalid response
            if (!response.data || typeof response.data !== 'object') {
                console.warn("useTimerDataImportDataCalendar: Invalid response data", response.data);
                return [];
            }
            
            // Transform object to array of [key, value] pairs
            const result = Object.keys(response.data).map((key) => [
                key,
                response.data[key],
            ]);
            return result;
        },
        {
            // Only enable query when token is available
            enabled: !!token,
            // Always fetch fresh data from database on mount
            // Cache is invalidated/removed in Calendar before navigation, so this ensures fresh fetch
            refetchOnMount: 'always', // Always refetch on mount to get fresh data from DB
            staleTime: 0, // Data is immediately stale, always fetch fresh
            cacheTime: 0, // Don't cache data, always fetch from DB
            onError: (error) => {
                console.error("useTimerDataImportDataCalendar error:", error);
                global.config.slackMessage?.(error.toString());
            },
        }
    );
}